export { COOKIE_NAME, ONE_YEAR_MS } from "@shared/const";
import { encodeOAuthState, OAUTH_STATE_COOKIE } from "@shared/const";

function buildLoginUrl(returnPath?: string) {
  const oauthPortalUrl = import.meta.env.VITE_OAUTH_PORTAL_URL;
  const appId = import.meta.env.VITE_APP_ID;
  const redirectUri = `${window.location.origin}/api/oauth/callback`;
  const nonce = crypto.randomUUID();
  const state = encodeOAuthState({ redirectUri, returnPath: returnPath ?? "/", nonce });

  document.cookie = `${OAUTH_STATE_COOKIE}=${encodeURIComponent(nonce)}; Path=/; Max-Age=600; SameSite=None; Secure`;

  const url = new URL(`${oauthPortalUrl}/login`);
  url.searchParams.set("app_id", appId);
  url.searchParams.set("redirect_url", redirectUri);
  url.searchParams.set("state", state);

  return url.toString();
}

/** Inicia o OAuth somente no momento da navegação, preservando o estado do navegador. */
export function startLogin(returnPath?: string) {
  window.location.assign(buildLoginUrl(returnPath));
}
